
        var result = require("!!../../../../node_modules/css-loader/index.js!./not-found.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/not-found/not-found.component.css
// module id = 1427
// module chunks = 0